import { InjectionToken } from '@angular/core';

import "moment/locale/es";

export interface FormInputsLocaleConfig {
  locale: string;
}

export const FORM_INPUTS_LOCALE_CONFIG = new InjectionToken<FormInputsLocaleConfig>(
  'FORM_INPUTS_LOCALE_CONFIG',
  {
    providedIn: 'root',
    factory: () => ({ locale: navigator.language })
  }
);